<template>
    <div class="background rounded-lg">
        <Block v-if="loading" />
        <v-row>
            <v-col cols="12">
                <v-radio-group v-model="typeData" class="ma-3">
                    <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
                    <v-radio label="Ver reporte con datos de producción" value="01"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>

        <div>
            <v-tabs v-model="tab">
                <v-tab href="#1">Ver reporte general</v-tab>
                <v-tab href="#2">Ver reporte detallado</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" touchless>
                <v-tab-item value="1">
                    <div class="versatile-filter-container">
                        <div class="row">
                            <div class="col-12 p-2">    
                                <VersatileFilter class="pt-3" 
                                    :columnsSearch.sync="columsConfig" 
                                    advancedFilter 
                                    requiredParams 
                                    :search="search" 
                                    @emptyFilter="getEarningDetail" 
                                    @filtered="filterHandler"
                                    :key="Reloadfilter" 
                                    :columnfilterEndpoint="getFilterEarningsColReport" 
                                    @getStart=" (date) => {changueStr(date)}" 
                                    @getEnd=" (date) => {changueEnd(date)}" 
                                    :extraParam1="typeData" 
                                    :extraParam2="selectedBranch ? selectedBranch.toString() : ''"
                                    :enableDateStatus="true"
                                    >
                                    
                                    <template v-slot:branchSelector 
                                        v-if="$store.getters['rolesUser/getCustomRole'](2) || $store.getters['rolesUser/getCustomRole'](268) || this.$store.getters['rolesUser/getArrayCustomRole']([277])">
                                        <v-select
                                            v-model="selectedBranch"
                                            :items="branches"
                                            item-text="BranchName"
                                            item-value="ID_Branch"
                                            label="Sucursal"
                                            @change="onBranchChange"
                                            :hint="currentBranch ? `${currentBranch}` : ''"
                                            persistent-hint
                                            style="min-width: 150px; max-width: auto;"
                                            dense
                                        >
                                        </v-select>
                                    </template>

                                    <template v-slot:complementFilters>
                                        <div class="d-flex align-center">
                                            <v-checkbox
                                                v-model="search.notCosts"
                                                label="Sin costos (más rápido)"
                                            ></v-checkbox>
                                            <v-checkbox
                                                class="mx-2"
                                                v-model="minReport"
                                                label="Reporte resumido"
                                            ></v-checkbox>

                                            <v-btn small color="primary" class="ml-auto" @click="onExportingToPdf()">
                                                <v-icon left>mdi-file-pdf-box</v-icon>
                                                Exportar PDF
                                            </v-btn>
                                        </div>
                                    </template>
                                    
                                    <DxDataGrid :data-source="reportsData" :show-borders="true"    
                                    :column-auto-width="true"  @exporting="onExporting"
                                    style="max-height: 600px;" :paging="{ enabled: false }">
                                    <DxScrolling 
                                    row-rendering-mode="virtual" 
                                    showScrollbar="always"
                                    useNative="false" />
                                    <DxExport :enabled="true" />
                                    <DxColumn data-field="ID_Invoice" caption="ID Factura" />
                                    <DxColumn data-field="BranchName" caption="Sucursal" v-if="!selectedBranch" />
                                    <DxColumn v-if="ShowCorrelativeControl" cell-template="correlative-idinvoice" caption="Correlativo interno"></DxColumn>
                                    <template #correlative-idinvoice="{data}">
                                        {{ data.data.Correlative ? data.data.Correlative : "" }}
                                    </template>
                                    <DxColumn data-field="InvoiceDate" caption="Fecha factura" />
                                    <DxColumn data-field="InvoiceTime" caption="Hora de factura" />
                                    <DxColumn data-field="ID_Customer" caption="ID CLiente" />
                                    <DxColumn data-field="LegalName" caption="Nombre Legal" />
                                    <DxColumn data-field="FeMhEstado" caption="Estado DTE" />
                                    <DxColumn data-field="VentaTerceroNombre" caption="Ventas a cuenta de terceros" />
                                    <DxColumn data-field="Discount" caption="Descuento" v-if="!minReport" />
                                    <DxColumn data-field="PriceNotIva" caption="Precio sin iva" v-if="!minReport" />
                                    <DxColumn data-field="InvoiceIvaPerce1" caption="Iva Perce" v-if="!minReport" />
                                    <DxColumn data-field="InvoiceIvaRete1" caption="Iva Rete" v-if="!minReport" />
                                    <DxColumn data-field="InvoiceReteRenta" caption="Rete Renta" v-if="!minReport" />
                                    <DxColumn data-field="InvoiceTotalExenta" caption="Exentas" />
                                    <DxColumn data-field="InvoiceTotalNoSuj" caption="No Sujetas" />
                                    <DxColumn data-field="InvoiceTotalNoGravado" caption="No gravadas" />
                                    <DxColumn data-field="InvoiceTotalGravada" caption="Gravadas" v-if="minReport"/>
                                    <DxColumn data-field="Iva" caption="Iva" />
                                    <DxColumn data-field="PriceWithIva" caption="Precio con iva"  v-if="!minReport" />
                                    <DxColumn data-field="Total" caption="Total"  v-if="minReport"/>
                                    <DxColumn data-field="CostNotIva" v-if="!search.notCosts || !minReport" caption="Costo sin iva" />
                                    <DxColumn data-field="CostIva" v-if="!search.notCosts || !minReport" caption="Iva del costo" />
                                    <DxColumn data-field="CostWithIva" v-if="!search.notCosts || !minReport" caption="Costo" />
                                    <DxColumn data-field="Earnings" caption="Ganancias" v-if="!minReport" />
                                    <DxColumn data-field="UserName" caption="Usuario" v-if="!minReport"/>
                                    <DxColumn data-field="FullUserName" caption="Nombre del usuario" />
                                    <DxColumn data-field="FullSellerName" caption="Nombre del vendedor" v-if="!minReport"/>
                                    <DxColumn data-field="TecnicalName" caption="Nombre del tecnico" v-if="usetechnical"/>
                                    <DxColumn data-field="TipoFactura" caption="Tipo de factura" v-if="!minReport" />
                                    <DxColumn data-field="Zona" caption="Zona" v-if="!minReport" />
                                    <DxColumn data-field="NIT" caption="NIT" />
                                    <DxColumn data-field="NRC" caption="NRC" />
                                    <DxColumn data-field="DUI" caption="DUI" />
                                    <DxColumn data-field="InvoiceType" caption="Tipo de factura" />
                                    <DxColumn data-field="EstadoDTE" caption="Estado comprobante" />
                                    <DxColumn data-field="DiasCredito" caption="Días de crédito" />
                                    <DxColumn data-field="CodigoGeneracion" caption="Código de generación" />
                                    <DxColumn data-field="NumeroControl" caption="Número de control" />
                                    <DxColumn data-field="SelloRecepcion" caption="Sello de recepción" />
                                </DxDataGrid>
                                </VersatileFilter>
                            </div>
                        </div>
                    <div class="black--text">
                      <div class="text-h4 text-center mb-6">Totales</div>
                        <v-card
                          rounded="lg"
                          class="mx-6 mb-10 py-2"
                          color="white"
                          elevation="5"
                        >
                          <v-row justify="center" v-if="minReport">
                            <v-col cols="12" sm="2" class="py-4 px-2">
                              <div class="text-center font-weight-bold">Exentas</div>
                              <div class="text-center text-h5 font-weight-light">
                                {{ Currency + " " + summary.exentas }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="2" class="py-4 px-2">
                              <div class="text-center font-weight-bold">No Sujetas</div>
                              <div class="text-center text-h5 font-weight-light">
                                {{ Currency + " " + summary.nosujetas }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="2" class="py-4 px-2">
                              <div class="text-center font-weight-bold">No Gravadas</div>
                              <div class="text-center text-h5 font-weight-light">
                                {{ Currency + " " + summary.nogravadas }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="2" class="py-4 px-2">
                              <div class="text-center font-weight-bold">Gravadas</div>
                              <div class="text-center text-h5 font-weight-light">
                                {{ Currency + " " + summary.gravadas }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="2" class="py-4 px-2">
                              <div class="text-center font-weight-bold">IVA</div>
                              <div class="text-center text-h5 font-weight-light">
                                {{ Currency + " " + summary.Iva }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="2" class="py-4 px-2">
                              <div class="text-center font-weight-bold">Total</div>
                              <div class="text-center text-h5 font-weight-light">
                                {{ Currency + " " + summary.total }}
                              </div>
                            </v-col>
                          </v-row>
                          <v-row justify="center" v-else>
                            <v-col cols="12" sm="2" class="py-4 px-2" v-show="!search.notCosts">
                              <div class="text-center font-weight-bold">Costos sin IVA</div>
                              <div class="text-center text-h5 font-weight-light">
                                {{ Currency + " " + summary.totalCost }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="2" class="py-4 px-2">
                              <div class="text-center font-weight-bold">Descuentos</div>
                              <div class="text-center text-h5 font-weight-light">
                                {{ Currency + " " + summary.totalDiscount }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="2" class="py-4 px-2">
                              <div class="text-center font-weight-bold">Ventas sin IVA</div>
                              <div class="text-center text-h5 font-weight-light">
                                {{ Currency + " " + summary.totalNotIva }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="2" class="py-4 px-2">
                              <div class="text-center font-weight-bold">Ventas</div>
                              <div class="text-center text-h5 font-weight-light">
                                {{ Currency + " " + summary.totalIva }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="2" class="py-4 px-2">
                              <div class="text-center font-weight-bold">Ganancias</div>
                              <div class="text-center text-h5 font-weight-light">
                                {{ Currency + " " + summary.totalEarnings }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-card>
                    </div>
                    </div> <!-- Cierre de versatile-filter-container -->
                </v-tab-item>
                <v-tab-item value="2">
                    <div class="versatile-filter-container">
                        <VersatileFilter :isAutoScrolled="true" class="pt-3" 
                            :columnsSearch.sync="columsConfig2" 
                            advancedFilter 
                            requiredParams 
                            :search="{ getGrouping: this.showGroupingNoDetails, noShowInvalidation: this.noShowInvalidation, getNoCosts:this.noCosts, getOnlyAirlaineTickets: this.getOnlyAirlaineTickets }" 
                            @emptyFilter="getEarningDetailByItems" 
                            @filtered="filterHandler2"
                            :key="Reloadfilter2" 
                            :columnfilterEndpoint="getFilterEarningsByItemColReport" 
                            @getStart=" (date) => {changueStr2(date)}" 
                            @getEnd=" (date) => {changueEnd2(date)}" 
                            :extraParam1="typeData" 
                            :extraParam2="selectedBranch ? selectedBranch.toString() : ''"
                            :enableDateStatus="true"
                            >
                            
                            <template v-slot:branchSelector v-if="$store.getters['rolesUser/getCustomRole'](2) || this.$store.getters['rolesUser/getArrayCustomRole']([277])">
                                <v-select
                                    v-model="selectedBranch"
                                    :items="branches"
                                    item-text="BranchName"
                                    item-value="ID_Branch"
                                    label="Sucursal"
                                    @change="onBranchChange"
                                    :hint="currentBranch ? `${currentBranch}` : ''"
                                    persistent-hint
                                    style="min-width: 150px; max-width: auto;"
                                    dense
                                >
                                </v-select>
                            </template>
                            
                        <v-row class="mt-2 ml-2">
                            <v-col cols="12" md="3">
                                <v-checkbox v-model="noCosts" @click="showGroupingNoDetails = false" label="Sin costos (más rápido)"></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-checkbox v-model="showGroupingDetails" @click="showGroupingNoDetails = false" label="Mostrar tabla agrupada"></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-checkbox v-model="showGroupingNoDetails" @click="showGroupingDetails = false" label="Mostrar totales por familia, categoría y subcategoría"></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="3" v-if="showGroupingNoDetails">
                                <v-checkbox v-model="noShowInvalidation" @change="getEarningDetailByItems" label="No incluir invalidaciones"></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="3" v-if="showformairlinetickets">
                                <v-checkbox v-model="getOnlyAirlaineTickets" @change="getEarningDetailByItems" label="Mostrar reporte de boletos vendidos"></v-checkbox>
                            </v-col>
                        </v-row>
                        <DxDataGrid v-if="showGroupingDetails == false && showGroupingNoDetails == false && getOnlyAirlaineTickets == false" 
                            :data-source="reportsData2" :show-borders="true"
                            :column-auto-width="true" @exporting="onExporting2"
                            style="max-height: 600px;" :paging="{ enabled: false }">
                            <DxScrolling 
                            row-rendering-mode="virtual" 
                            showScrollbar="always"
                            useNative="false" />
                            <DxExport :enabled="true" />
                            <DxColumn data-field="ID_Invoice" caption="ID Factura" />
                            <DxColumn data-field="BranchName" caption="Sucursal" v-if="!selectedBranch" />
                            <DxColumn v-if="ShowCorrelativeControl" cell-template="correlative-idinvoice" caption="Correlativo interno"></DxColumn>
                            <template #correlative-idinvoice="{data}">
                                {{ data.data.Correlative ? data.data.Correlative : "" }}
                            </template>
                            <DxColumn data-field="InvoiceDate" caption="Fecha factura" />
                            <DxColumn data-field="InvoiceTime" caption="Hora factura" />
                            <DxColumn data-field="FeMhEstado" caption="Estado DTE" />
                            <DxColumn data-field="ID_Customer" caption="ID CLiente" />
                            <DxColumn data-field="LegalName" caption="Nombre Legal" />
                            <DxColumn data-field="ID_Item" caption="ID Producto/Servicio" />
                            <DxColumn data-field="CodigoAlterno" caption="Código alterno principal" />
                            <DxColumn data-field="ItemType" caption="Tipo" />
                            <DxColumn data-field="ItemQuantity" caption="Cantidad" />
                            <DxColumn data-field="ItemMeasureUnit" caption="Unidad de medida" />
                            <DxColumn data-field="ItemDescription" caption="Descripción" />
                            <DxColumn data-field="ItemUnitPrice" caption="Precio unitario" />
                            <DxColumn data-field="ItemDiscount" caption="Descuento" />
                            <DxColumn data-field="ItemDiscountPercent" caption="Descuento (%)" />
                            <DxColumn data-field="ItemGravada" caption="Total Con Iva" />
                            <DxColumn data-field="ItemPriceSinIVA" caption="Total Gravado" />
                            <DxColumn data-field="ItemNoSuj" caption="Total No Suj" />
                            <DxColumn data-field="ItemExenta" caption="Total Exenta" />
                            <DxColumn data-field="ItemIVA" caption="IVA" />
                            <DxColumn data-field="WarehouseName" caption="Almacén" />
                            <DxColumn data-field="familyName" caption="Familía" />
                            <DxColumn data-field="categoryName" caption="Categoría" />
                            <DxColumn data-field="subcategoryName" caption="Subcategoría" />
                            <DxColumn data-field="CostNotIva" caption="Costo sin iva" v-if="!noCosts" />
                            <DxColumn data-field="CostIva" caption="Iva del costo" v-if="!noCosts"/>
                            <DxColumn data-field="CostWithIva" caption="Costo" v-if="!noCosts"/>
                            <DxColumn data-field="Earnings" caption="Ganacia" v-if="!noCosts" />
                            <DxColumn data-field="UserName" caption="Usuario" />
                            <DxColumn data-field="FullUserName" caption="Nombre del usuario" />
                            <DxColumn data-field="FullSellerName" caption="Nombre del vendedor" />
                            <DxColumn data-field="TecnicalName" caption="Nombre del tecnico" v-if="usetechnical"/>
                            <DxColumn data-field="Zona" caption="Zona" />
                            <DxColumn data-field="NIT" caption="NIT" />
                            <DxColumn data-field="NRC" caption="NRC" />
                            <DxColumn data-field="DUI" caption="DUI" />
                            <DxColumn data-field="InvoiceType" caption="Tipo de factura" />
                            <DxColumn data-field="EstadoDTE" caption="Estado del DTE" />
                            <DxColumn data-field="DiasCredito" caption="Días de crédito" />
                            <DxColumn data-field="CodigoGeneracion" caption="Código de generación" />
                            <DxColumn data-field="NumeroControl" caption="Número de control" />
                            <DxColumn data-field="SelloRecepcion" caption="Sello de recepción" />
                        </DxDataGrid>

                        <DxDataGrid v-if="showGroupingDetails == false && showGroupingNoDetails == false && getOnlyAirlaineTickets == true" 
                            :data-source="reportsData2" :show-borders="true"
                            :column-auto-width="true" @exporting="onExporting2"
                            style="max-height: 600px;" :paging="{ enabled: false }">
                            <DxScrolling 
                            row-rendering-mode="virtual" 
                            showScrollbar="always"
                            useNative="false" />
                            <DxExport :enabled="true" />
                            <DxColumn data-field="ID_Invoice" caption="ID Factura" />
                            <DxColumn data-field="BranchName" caption="Sucursal" v-if="!selectedBranch" />
                            <DxColumn v-if="ShowCorrelativeControl" cell-template="correlative-idinvoice" caption="Correlativo interno"></DxColumn>
                            <template #correlative-idinvoice="{data}">
                                {{ data.data.Correlative ? data.data.Correlative : "" }}
                            </template>
                            <DxColumn data-field="InvoiceDate" caption="Fecha factura" />
                            <DxColumn data-field="InvoiceTime" caption="Hora factura" />
                            <DxColumn data-field="FeMhEstado" caption="Estado DTE" />
                            <DxColumn data-field="ID_Customer" caption="ID CLiente" />
                            <DxColumn data-field="LegalName" caption="Nombre Legal" />
                            <DxColumn data-field="ID_Item" caption="ID Producto/Servicio" />
                            <DxColumn data-field="LineaAerea" caption="Linea Aerea" />
                            <DxColumn data-field="Boleto" caption="Boleto" />
                            <DxColumn data-field="Pasajero" caption="Pasajero" />
                            <DxColumn data-field="Ruta" caption="Ruta" />
                            <DxColumn data-field="ItemQuantity" caption="Cantidad" />
                            <DxColumn data-field="ItemUnitPrice" caption="Precio unitario" />
                            <DxColumn data-field="ItemDiscount" caption="Descuento" />
                            <DxColumn data-field="ItemDiscountPercent" caption="Descuento (%)" />
                            <DxColumn data-field="ItemNoSuj" caption="Total No Suj" />
                            <DxColumn data-field="ItemExenta" caption="Total Exenta" />
                            <DxColumn data-field="ItemPriceSinIVA" caption="Total Gravado" />
                            <DxColumn data-field="ItemGravada" caption="Total Con Iva" />
                            <DxColumn data-field="ItemIVA" caption="IVA" />
                            <DxColumn data-field="CostNotIva" caption="Costo sin iva" v-if="!noCosts" />
                            <DxColumn data-field="CostIva" caption="Iva del costo" v-if="!noCosts"/>
                            <DxColumn data-field="CostWithIva" caption="Costo" v-if="!noCosts"/>
                            <DxColumn data-field="Earnings" caption="Ganacia" v-if="!noCosts" />
                            <DxColumn data-field="UserName" caption="Usuario" />
                            <DxColumn data-field="FullUserName" caption="Nombre del usuario" />
                            <DxColumn data-field="FullSellerName" caption="Nombre del vendedor" />
                            <DxColumn data-field="TecnicalName" caption="Nombre del tecnico" v-if="usetechnical"/>
                            <DxColumn data-field="Zona" caption="Zona" />
                            <DxColumn data-field="NIT" caption="NIT" />
                            <DxColumn data-field="NRC" caption="NRC" />
                            <DxColumn data-field="DUI" caption="DUI" />
                            <DxColumn data-field="InvoiceType" caption="Tipo de factura" />
                            <DxColumn data-field="EstadoDTE" caption="Estado del DTE" />
                            <DxColumn data-field="DiasCredito" caption="Días de crédito" />
                            <DxColumn data-field="CodigoGeneracion" caption="Código de generación" />
                            <DxColumn data-field="NumeroControl" caption="Número de control" />
                            <DxColumn data-field="SelloRecepcion" caption="Sello de recepción" />
                        </DxDataGrid>

                        <DxDataGrid v-if="showGroupingDetails == true && showGroupingNoDetails == false && getOnlyAirlaineTickets == false" class="isScrolledByGeneralFilter" :data-source="reportsData2" 
                            :show-borders="true"
                            style="max-height: 600px;" :column-auto-width="true"  @exporting="onExporting3" :paging="{ enabled: false }">
                            <DxExport :enabled="true" />
                            <DxScrolling 
                            row-rendering-mode="virtual" 
                            showScrollbar="always"
                            useNative="false" />
                            <!--DxColumn :group-index="0" data-field="WarehouseName" caption="Almacén" :sortOrder="'asc'" /-->
                            <DxColumn :group-index="0" caption="Familia: " :calculate-display-value="getCustomCell" />
                            <DxColumn data-field="ID_Invoice" caption="ID Factura" />
                            <DxColumn data-field="BranchName" caption="Sucursal" v-if="!selectedBranch" />
                            <DxColumn data-field="InvoiceDate" caption="Fecha factura" />
                            <DxColumn data-field="FeMhEstado" caption="Estado DTE" />
                            <DxColumn data-field="InvoiceTime" caption="Hora factura" />
                            <DxColumn data-field="ID_Customer" caption="ID CLiente" />
                            <DxColumn data-field="LegalName" caption="Nombre Legal" />
                            <DxColumn data-field="ID_Item" caption="ID Producto/Servicio" />
                            <DxColumn data-field="CodigoAlterno" caption="Código alterno principal" />
                            <DxColumn data-field="ItemType" caption="Tipo" />
                            <DxColumn data-field="ItemQuantity" caption="Cantidad" />
                            <DxColumn data-field="ItemMeasureUnit" caption="Unidad de medida" />
                            <DxColumn data-field="ItemDescription" caption="Descripción" />
                            <DxColumn data-field="ItemUnitPrice" caption="Precio unitario" />
                            <DxColumn data-field="ItemDiscount" caption="Descuento" />
                            <DxColumn data-field="ItemDiscountPercent" caption="Descuento (%)" />
                            <DxColumn data-field="ItemGravada" caption="Total Con Iva" />
                            <DxColumn data-field="ItemPriceSinIVA" caption="Total Gravado" />
                            <DxColumn data-field="ItemNoSuj" caption="Total No Suj" />
                            <DxColumn data-field="ItemExenta" caption="Total Exenta" />
                            <DxColumn data-field="ItemIVA" caption="IVA" />
                            <DxColumn data-field="CostNotIva" caption="Costo sin iva" />
                            <DxColumn data-field="CostIva" caption="Iva del costo" />
                            <DxColumn data-field="CostWithIva" caption="Costo" />
                            <DxColumn data-field="Earnings" caption="Ganacia" />
                            <DxColumn data-field="UserName" caption="Usuario" />
                            <DxColumn data-field="FullUserName" caption="Nombre del usuario" />
                            <DxColumn data-field="FullSellerName" caption="Nombre del vendedor" />
                            <DxColumn data-field="Zona" caption="Zona" />
                            <DxColumn data-field="NIT" caption="NIT" />
                            <DxColumn data-field="NRC" caption="NRC" />
                            <DxColumn data-field="DUI" caption="DUI" />
                            <DxColumn data-field="InvoiceType" caption="Tipo de factura" />
                            <DxColumn data-field="EstadoDTE" caption="Estado" />
                            <DxColumn data-field="DiasCredito" caption="Días de crédito" />
                            <DxColumn data-field="CodigoGeneracion" caption="Código de generación" />
                            <DxColumn data-field="NumeroControl" caption="Número de control" />

                            <DxSummary >
                                <DxGroupItem
                                :show-in-group-footer="true"
                                column="ItemGravada"
                                summary-type="sum"
                                :value-format="customCurrencyFormat"
                                display-format="Total Con Iva: {0}"
                                />
                                <DxGroupItem
                                :show-in-group-footer="true"
                                column="ItemPriceSinIVA"
                                summary-type="sum"
                                :value-format="customCurrencyFormat"
                                display-format="Total Gravada: {0}"
                                />
                                <DxGroupItem
                                :show-in-group-footer="true"
                                column="ItemNoSuj"
                                summary-type="sum"
                                :value-format="customCurrencyFormat"
                                display-format="Total No Suj: {0}"
                                />
                                <DxGroupItem
                                :show-in-group-footer="true"
                                column="ItemExenta"
                                summary-type="sum"
                                :value-format="customCurrencyFormat"
                                display-format="Total Exento: {0}"
                                />
                                <DxGroupItem
                                :show-in-group-footer="true"
                                column="ItemIVA"
                                summary-type="sum"
                                :value-format="customCurrencyFormat"
                                display-format="Total IVA: {0}"
                                />
                                <DxGroupItem
                                :show-in-group-footer="true"
                                column="CostNotIva"
                                summary-type="sum"
                                :value-format="customCurrencyFormat"
                                display-format="Total Costo sin IVA: {0}"
                                />
                                <DxGroupItem
                                :show-in-group-footer="true"
                                column="CostIva"
                                summary-type="sum"
                                :value-format="customCurrencyFormat"
                                display-format="Total IVA de costos: {0}"
                                />
                                <DxGroupItem
                                :show-in-group-footer="true"
                                column="CostWithIva"
                                summary-type="sum"
                                :value-format="customCurrencyFormat"
                                display-format="Total Costo con IVA: {0}"
                                />
                                <DxGroupItem
                                :show-in-group-footer="true"
                                column="Earnings"
                                summary-type="sum"
                                :value-format="customCurrencyFormat"
                                display-format="Total Ganancias: {0}"
                                />
                            </DxSummary>
                        </DxDataGrid>
                        <template v-if="showGroupingNoDetails == true && showGroupingDetails == false && getOnlyAirlaineTickets == false">
                            <br/>
                            <!--h3 class="ml-5" >Resumen por almacén: </h3>
                            <DxDataGrid class="isScrolledByGeneralFilter" 
                            :data-source="dataGroupWarehouse" 
                            :show-borders="true"
                            style="max-height: 600px;" :column-auto-width="true"  @exporting="onExporting" :paging="{ enabled: false }"
                            :show-empty="false">
                                <DxExport :enabled="true" />
                                <DxScrolling  
                                showScrollbar="always"
                                useNative="false"
                                />
                                <DxColumn data-field="WarehouseName" caption="Almacén" />
                                <DxColumn data-field="TotalPriceSinIVA" caption="Venta total sin IVA" />
                                <DxColumn data-field="TotalIVA" caption="Total IVA de venta" />
                                <DxColumn data-field="CostoTotalSinIVA" caption="Costo total sin IVA" />
                                <DxColumn data-field="IVATotalCosto" caption="Total IVA de costo" />
                                <DxColumn data-field="TotalCosto" caption="Total Costo" />
                                <DxColumn data-field="TotalGanancia" caption="Total Ganancia" />
                            </DxDataGrid-->

                            <br/>
                            <h3 class="ml-5">Resumen por familia, categoría y subcategoría: </h3>
                            <DxDataGrid class="isScrolledByGeneralFilter"
                            key="dataGroupFamilies" 
                            :data-source="dataGroupFamilies" 
                            :show-borders="true"
                            style="max-height: 600px;" :column-auto-width="true"  @exporting="onExporting4" :paging="{ enabled: false }"
                            :show-empty="false"
                            :auto-generate-columns="false">
                                <DxExport :enabled="true" />
                                <DxScrolling  
                                showScrollbar="always"
                                useNative="false"
                                />
                                <DxColumn data-field="familyName" caption="Familia" />
                                <DxColumn data-field="categoryName" caption="Categoría" />
                                <DxColumn data-field="subcategoryName" caption="Subcategoría" />
                                <DxColumn data-field="TotalPriceSinIVA" caption="Venta total sin IVA" cell-template="cellNumber" />
                                <DxColumn data-field="TotalIVA" caption="Total IVA de venta" cell-template="cellNumber" />
                                <DxColumn data-field="sumaTotal" caption="Total venta" cell-template="cellNumber"/>
                                <DxColumn data-field="CostoTotalSinIVA" caption="Costo total sin IVA" cell-template="cellNumber"/>
                                <DxColumn data-field="IVATotalCosto" caption="Total IVA de costo" cell-template="cellNumber"/>
                                <DxColumn data-field="TotalCosto" caption="Total Costo" cell-template="cellNumber"/>
                                <DxColumn data-field="TotalGanancia" caption="Total Ganancia" cell-template="cellNumber"/>
                                <template #cellNumber="{ data }">
                                    <div style="text-align: right; width: 100%;">
                                        {{ data.value }}
                                    </div>
                                </template>
                                <DxSummary>
                                    <DxTotalItem 
                                    column="familyName"
                                    show-in-column="familyName"
                                    summary-type="count"
                                    :customize-text="() => 'Totales'"
                                    />

                                    <DxTotalItem 
                                        column="TotalPriceSinIVA"
                                        show-in-column="TotalPriceSinIVA"
                                        summary-type="sum"
                                        display-format="{0}" 
                                        :value-format="{ type: 'fixedPoint', precision: 2 }" />

                                    <DxTotalItem 
                                        column="TotalIVA"
                                        show-in-column="TotalIVA"
                                        summary-type="sum"
                                        display-format="{0}" 
                                        :value-format="{ type: 'fixedPoint', precision: 2 }" />

                                    <DxTotalItem 
                                        column="sumaTotal"
                                        show-in-column="sumaTotal"
                                        summary-type="sum"
                                        display-format="{0}" 
                                        :value-format="{ type: 'fixedPoint', precision: 2 }" />

                                    <DxTotalItem 
                                        column="CostoTotalSinIVA"
                                        show-in-column="CostoTotalSinIVA"
                                        summary-type="sum"
                                        display-format="{0}" 
                                        :value-format="{ type: 'fixedPoint', precision: 2 }" />

                                    <DxTotalItem 
                                        column="IVATotalCosto"
                                        show-in-column="IVATotalCosto"
                                        summary-type="sum"
                                        display-format="{0}" 
                                        :value-format="{ type: 'fixedPoint', precision: 2 }" />

                                    <DxTotalItem 
                                        column="TotalCosto"
                                        show-in-column="TotalCosto"
                                        summary-type="sum"
                                        display-format="{0}" 
                                        :value-format="{ type: 'fixedPoint', precision: 2 }" />

                                    <DxTotalItem 
                                        column="TotalGanancia"
                                        show-in-column="TotalGanancia"
                                        summary-type="sum"
                                        display-format="{0}" 
                                        :value-format="{ type: 'fixedPoint', precision: 2 }" />

                                </DxSummary>
                            </DxDataGrid>
                        </template>
                    </VersatileFilter>
                    </div> <!-- Cierre de versatile-filter-container -->
                </v-tab-item>
            </v-tabs-items>
        </div>
    </div>

</template>

<script>
//import GeneralFilter from '@/components/GeneralFilter';
import VersatileFilter from '@/components/VersatileFilter';
import { 
    DxDataGrid, 
    DxColumn, 
    DxExport, 
    DxScrolling, 
    DxSummary, 
    DxGroupItem,
    DxTotalItem,
    } from 'devextreme-vue/data-grid';
import Block from '@/components/Block.vue';
//import DatePicker from '@/components/DatePicker';
import { numberWithCommas } from '@/helpers/money';
import { printToExcel } from "@/helpers/printToexcel";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
    export default {
        name: "EarningDetail",
        components: {
           // GeneralFilter,
           // DatePicker,
            DxDataGrid,
            DxColumn,
            DxExport,
            VersatileFilter,
            DxScrolling, 
            DxSummary,
            DxGroupItem,
            Block,
            DxTotalItem,
        },
        props: ['win','datafilter'],
        data() {
            return {
                tab: '01',
                panel: 0,
                reportsData : [],
                reportsData2 : [],
                dataGroupWarehouse: [],
                dataGroupFamilies: [],
                typeData: '01',
                selectedBranch: null,
                branches: [],
                currentBranch: null,
                loading: false,
                start: null,
                start2: null,
                end: null,
                end2: null,
                Reloadfilter: 0,
                Reloadfilter2: 0,
                summary: {
                    totalCost: 0.00,
                    totalDiscount: 0.00,
                    totalNotIva: 0.00,
                    totalIva: 0.00,
                    totalEarnings: 0.00,
                    Iva: 0.00, 
                    exentas: 0.00,
                    nosujetas: 0.00,
                    nogravadas: 0.00,
                    gravadas: 0.00,
                    total: 0.00,
                },
                search: {
                    notCosts: false,
                }, 
                search2: {},
                Currency: '',
                columsConfig: [
                    {
                        name: 'ID_User',
                        title: 'Usuario',
                        value: '',
                        type: 'select',
                        options: [],
                    },
                    {
                        name: 'ID_Seller',
                        title: 'Vendedor',
                        value: '',
                        type: 'select',
                        options: [],
                    },
                    {
                        name: "ID_Invoice",
                        title: "ID Factura",
                        value: "",
                        type: "text",
                    },
                    {
                        name: "LegalName",
                        title: "Nombre Del Cliente",
                        value: "",
                        type: "text",
                    },
                    {
                        name: "NumeroControl",
                        title: "Numero de Control",
                        value: "",
                        type: "text",
                    },
                    {
                        name: "CodigoGeneracion",
                        title: "Codigo de Generación",
                        value: "",
                        type: "text",
                    },
                    {
                        name: "InvoiceType",
                        title: 'Tipo de Factura',
                        value: '',
                        type: 'select',
                        options: [
                            { name: 'CONSUMIDOR FINAL', value: 'FCF' },
                            { name: 'CRÉDITO FISCAL',      value: 'CCF' },
                            { name: 'SUJETO EXCLUIDO',      value: 'FNS' },
                            { name: 'EXPORTACIÓN',          value: 'FEX' },
                            { name: 'COMPROBANTE DE DONACIÓN', value: 'CDD' },
                            { name: 'TICKETS',              value: 'TCKS' },
                            { name: 'NOTA DE REMISIÓN',     value: 'DNR' },
                            { name: 'EVENTO DE RETORNO',     value: 'FER' },
                            { name: 'NOTA DE CRÉDITO',      value: 'DNC' },
                        ]
                    },
                ],
                columsConfig2: [
                    {
                        name: 'ItemType',
                        title: 'Filtrar por tipo',
                        value: '',
                        type: 'select',
                        options: [
                            { name: 'Producto', value: 'product' }, 
                            { name: 'Servicio', value: 'service' }
                        ]
                    },
                    {
                        name: 'ItemMeasureUnit',
                        title: 'Unidad de medida',
                        value: '',
                        type: 'select',
                        options: []
                    },
                    {
                        name: 'Warehouse',
                        title: 'Almacén',
                        value: '',
                        type: 'select',
                        options: []
                    },
                    {
                        name: 'family',
                        title: 'Familía',
                        value: '',
                        type: 'select',
                        options: []
                    },
                    {
                        name: 'category',
                        title: 'Categoría',
                        parent: 'family',
                        value: '',
                        type: 'select',
                        options: []
                    },
                    {
                        name: 'subcategory',
                        title: 'Subcategoría',
                        parent: 'category',
                        value: '',
                        type: 'select',
                        options: []
                    },
                    {
                        name: 'ID_User',
                        title: 'Usuario',
                        value: '',
                        type: 'select',
                        options: [],
                    },
                    {
                        name: 'ID_Seller',
                        title: 'Vendedor',
                        value: '',
                        type: 'select',
                        options: [],
                    },
                    {
                        name: "ID_Invoice",
                        title: "ID Factura",
                        value: "",
                        type: "text",
                    },
                    {
                        name: "LegalName",
                        title: "Nombre Del Cliente",
                        value: "",
                        type: "text",
                    },
                    {
                        name: "NumeroControl",
                        title: "Numero de Control",
                        value: "",
                        type: "text",
                    },
                    {
                        name: "CodigoGeneracion",
                        title: "Codigo de Generación",
                        value: "",
                        type: "text",
                    },
                    {
                        name: "InvoiceType",
                        title: 'Tipo de Factura',
                        value: '',
                        type: 'select',
                        options: [
                            { name: 'CONSUMIDOR FINAL', value: 'FCF' },
                            { name: 'CRÉDITO FISCAL',      value: 'CCF' },
                            { name: 'SUJETO EXCLUIDO',      value: 'FNS' },
                            { name: 'EXPORTACIÓN',          value: 'FEX' },
                            { name: 'COMPROBANTE DE DONACIÓN', value: 'CDD' },
                            { name: 'TICKETS',              value: 'TCKS' },
                            { name: 'NOTA DE REMISIÓN',     value: 'DNR' },
                            { name: 'EVENTO DE RETORNO',     value: 'FER' },
                            { name: 'NOTA DE CRÉDITO',      value: 'DNC' },
                        ]
                    },
                ],
                showGroupingDetails: false,
                getOnlyAirlaineTickets: false,
                noShowInvalidation: false,
                noCosts: ['a12ef4cdfb07df951276aec9f7ae353d'].includes(JSON.parse(localStorage.getItem('user'))?.keymaster) ?? false,
                showGroupingNoDetails: false,
                showformairlinetickets: JSON.parse(localStorage.getItem("user")).showformairlinetickets,
                ShowCorrelativeControl: JSON.parse(localStorage.getItem("user")).showcorrelativecontrol,
                AuthFeMode: JSON.parse(localStorage.getItem("branch"))?.AuthFeMode,
                isInitializing: true,
                usetechnical: JSON.parse(localStorage.getItem('user'))?.usetechnical || 0,
                keymaster:JSON.parse(localStorage.getItem('user'))?.keymaster,
                minReport: false,
            }
        },
        watch: {
            typeData: function() {
                if (this.isInitializing) return ;
                this.getEarningDetail();
                this.getEarningDetailByItems();
            },
            showGroupingNoDetails: function() {
                this.getEarningDetailByItems();
            },
            selectedBranch: function() {
                // this.getEarningDetail();
                // this.getEarningDetailByItems();
            },
        },
        computed:{
            isNewTravel(){
                return this.keymaster == "452476470895e11843a44d7053b6521e";
            }
        },
        mounted() {
            try {
                this.start = new Date().toISOString().substr(0, 10);
                this.start2 = new Date().toISOString().substr(0, 10);
                this.end = new Date().toISOString().substr(0, 10);
                this.end2 = new Date().toISOString().substr(0, 10);
                this.Currency = JSON.parse(localStorage.getItem('branch')).Currency;
                this.minReport = this.isNewTravel;
                this.search.notCosts = this.isNewTravel;
                //console.log( 'this.Currency ', this.Currency );
                //this.getEarningDetailByItems();
                this.technicalSelect();
                this.assignParams();
                this.getBranches();
                this.typeData = '0' + this.AuthFeMode;
                this.$nextTick(() => {
                    this.isInitializing = false;
                });
                
            } catch (error) {
                console.log( 'Error', error );
            }
        },
        methods: {
            technicalSelect() {
                if (!this.usetechnical) return

                const technicalColumn = {
                    name: 'ID_Technical',
                    title: 'Técnico',
                    value: '',
                    type: 'select',
                    options: [],
                }

                const sellerIndex1 = this.columsConfig.findIndex(i => i.name === 'ID_Seller')
                if (sellerIndex1 !== -1 && !this.columsConfig.find(i => i.name === 'ID_Technical')) {
                    this.columsConfig.splice(sellerIndex1 + 1, 0, technicalColumn)
                }

                const sellerIndex2 = this.columsConfig2.findIndex(i => i.name === 'ID_Seller')
                if (sellerIndex2 !== -1 && !this.columsConfig2.find(i => i.name === 'ID_Technical')) {
                    this.columsConfig2.splice(sellerIndex2 + 1, 0, { ...technicalColumn })
                }
            },
            async onExportingToPdf() {
                const doc = new jsPDF({
                    orientation: "landscape",
                });

                    const [ businessInfo ] = await this.$API.branches.findSpecificBranch({ branch: JSON.parse(localStorage.getItem("user")).branch, business: JSON.parse(localStorage.getItem("user")).businessid })
                                 
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const title = `REPORTE DE VENTAS ${businessInfo.BusinessBillingName}`;
                    const titleFontSize = 14;
                    doc.setFontSize(titleFontSize);
                    const textWidth = doc.getTextWidth(title);
                    const xCenter = (pageWidth - textWidth) / 2;
                    doc.text(title, xCenter, 20);

                    const subtitle = `DEL ${this.start} AL ${this.end}`;
                    doc.setFontSize(12);
                    const subtitleWidth = doc.getTextWidth(subtitle);
                    const subtitleX = (pageWidth - subtitleWidth) / 2;
                    doc.text(subtitle, subtitleX, 28); // Y = 28 (debajo del título)

                    let head = [
                        ['ID FACTURA','FECHA','NOMBRE LEGAL','PRECIO SIN IVA','IVA RERC','IVA RETE','RETE RENTA','EXENTAS','NO SUJETAS','IVA','PRECIO CON IVA','NOMBRE USUARIO','NOMBRE VENDEDOR','TIPO','ESTADO DTE','DIAS DE CRÉDITO','NÚMERO DE CONTROL'],
                    ]
                    let body = [];
                    let columnsReport = {
                            0: { cellWidth: 30 }, // ID_FACTURA
                            1: { cellWidth: 15 }, // Fecha
                            2: { cellWidth: 30 }, // Nombre legal
                            3: { cellWidth: 15, halign: 'right' },//Precio sin iva
                            4: { cellWidth: 10, halign: 'right' },//Iva perc
                            5: { cellWidth: 10, halign: 'right' },//Iva rete
                            6: { cellWidth: 15, halign: 'right' },//Rete renta
                            7: { cellWidth: 15, halign: 'right' },//Exentas
                            8: { cellWidth: 15, halign: 'right' },//No sujetas
                            9: { cellWidth: 15, halign: 'right' },//Iva
                            10: { cellWidth: 15, halign: 'right' },//Precio con iva
                            11: { cellWidth: 20 },//nombre usuario
                            12: { cellWidth: 20 },//nombre vendedor
                            13: { cellWidth: 10 },//tipo factura
                            14: { cellWidth: 15 },//Estado DTE
                            15: { cellWidth: 15 },//Dias de credito
                            16: { cellWidth: 20 },//Numero control
                        };
                    if (this.minReport) {
                        head = [
                            [
                                "ID Factura","Fecha", "Nombre Legal", 
                                "Ventas a cuenta de terceros", "Exentas", "No Sujetas", 
                                "No gravadas", "Gravadas", "IVA", 
                                "Total", "Usuario", "Tipo", 
                                "Estado", "Crédito", "Número de control"
                            ]
                        ];
                        body = this.reportsData.map((item) => [
                            item.ID_Invoice,
                            item.InvoiceDate,
                            item.LegalName,
                            item.VentaTerceroNombre,
                            item.InvoiceTotalExenta,
                            item.InvoiceTotalNoSuj,
                            item.InvoiceTotalNoGravado,
                            item.InvoiceTotalGravada,
                            item.Iva,
                            item.Total,
                            item.FullUserName,
                            item.InvoiceType,
                            item.EstadoDTE,
                            item.DiasCredito,
                            item.NumeroControl
                        ]);
                        columnsReport = {
                            0: { cellWidth: 30, halign: 'left' }, // ID_FACTURA
                            1: { cellWidth: 15, halign: 'left' }, // Fecha
                            2: { cellWidth: 30, halign: 'left' }, // Nombre legal
                            3: { cellWidth: 30, halign: 'left' }, // Ventas a cuenta de terceros
                            4: { cellWidth: 15, halign: 'right' },//Exentas
                            5: { cellWidth: 15, halign: 'right' },//No Sujetas
                            6: { cellWidth: 15, halign: 'right' },//No gravadas
                            7: { cellWidth: 15, halign: 'right' },//Gravadas
                            8: { cellWidth: 15, halign: 'right' },//IVA
                            9: { cellWidth: 15, halign: 'right' },//Total
                            10: { cellWidth: 20, halign: 'left' },//Usuario
                            11: { cellWidth: 13, halign: 'left' },//Tipo de factura
                            12: { cellWidth: 15, halign: 'left' },//Estado comprobante
                            13: { cellWidth: 12, halign: 'left' },//Días de crédito
                            14: { cellWidth: 30, halign: 'left' },//Número de control
                        };
                    }else{                   
                        body = this.reportsData.map((item) => [
                            item.ID_Invoice,
                            item.InvoiceDate,
                            item.LegalName,
                            item.PriceNotIvaFormatted,
                            item.InvoiceIvaPerce1Formatted,
                            item.InvoiceIvaRete1Formatted,
                            item.InvoiceReteRentaFormatted,
                            item.InvoiceTotalExentaFormatted,
                            item.InvoiceTotalNoSujFormatted,
                            item.IvaFormatted,
                            item.PriceWithIvaFormatted,
                            item.FullUserName,
                            item.FullSellerName,
                            item.InvoiceType,
                            item.EstadoDTE,
                            item.DiasCredito,
                            item.NumeroControl
                        ]);
                    }
                    console.log('WWWWWW', this.$clone(this.reportsData))
                    console.log('FFFFFFF', this.$clone(this.summary))

                    const tableConfig = {
                        startY: 38,
                        head, //Encabezados columnas
                        body, //Datos de la tabla
                        theme: 'plain', // Estilo de la tabla
                        headStyles: { fillColor: [255, 255, 255], fontSize: 6 },
                        bodyStyles: { fontSize: 6 },
                        margin: { left: 5, right: 5 }, // Márgenes
                        styles: {
                            lineWidth: 0.2,       // Grosor de la línea
                            lineColor: [150, 150, 150], // Color de la línea (negro)
                        },
                        columnStyles: columnsReport
                    };

                    doc.autoTable(tableConfig);
                    const formatMoney =(val)=> {
                        if(!val) return '0.00';
                        return parseFloat(val).toFixed(2);
                    }
                    let headTotals = [['TOTAL COSTOS SIN IVA', 'TOTAL DESCUENTOS', 'TOTAL VENTAS SIN IVA', 'TOTAL VENTAS', 'TOTAL GANANCIAS']]
                    let bodyTotals = [[`$${this.summary.totalCost}`, `$${this.summary.totalDiscount}`, `$${this.summary.totalNotIva}`, `$${this.summary.totalIva}`, `$${this.summary.totalEarnings}`]]
                    if (this.minReport) {
                        headTotals = [['Exentas','No Sujetas','No Gravadas','Gravadas','IVA', 'TOTAL VENTAS']]
                        bodyTotals = [[
                            `$${formatMoney(this.summary.exentas)}`,
                            `$${formatMoney(this.summary.nosujetas)}`,
                            `$${formatMoney(this.summary.nogravadas)}`, 
                            `$${formatMoney(this.summary.gravadas)}`, 
                            `$${formatMoney(this.summary.Iva)}`, 
                            `$${formatMoney(this.summary.total)}`]]
                    }
                    const finalY = doc.lastAutoTable.finalY;

                    const totals = {
                        startY: finalY + 10,
                        head:headTotals,
                        body: bodyTotals,
                        theme: 'plain', // Estilo de la tabla
                        headStyles: { fillColor: [255, 255, 255], fontSize: 9 },
                        bodyStyles: { fontSize: 9 },
                        margin: { left: 5, right: 5 }, // Márgenes
                        tableWidth: 'auto', // Ancho automático de las columnas
                        styles: {
                            lineWidth: 0.2,       // Grosor de la línea
                            lineColor: [150, 150, 150], // Color de la línea (negro)
                            halign: 'center'
                        },
                    }
                    
                    doc.autoTable(totals)
                    doc.save(`REPORTE DE VENTAS ${this.start} - ${this.end}`);
            },
            getFilterEarningsColReport(e){
                return this.$API.inventoryReports.getFilterEarningsColReport(e);
            },
            getFilterEarningsByItemColReport(e){
                return this.$API.inventoryReports.getFilterEarningsByItemColReport(e);
            },
            customCurrencyFormat(value) {
                if (value == null) return ''; // Si el valor es nulo, retorna cadena vacía
                return '$' + parseFloat(value).toFixed(2); // Formato de moneda con 4 decimales
            },
            getCustomCell(rowData) {
                const familyName = rowData.familyName || 'Ninguna'; // Reemplaza null con una cadena vacía
                const categoryName = rowData.categoryName || 'Ninguna'; 
                const subcategoryName = rowData.subcategoryName || 'Ninguna';

                return `${familyName} - Categoría: ${categoryName} - Subcategoría: ${subcategoryName}`;
            },
            formatMoneyField(value){
                return `${ this.Currency }${ numberWithCommas( value ) }`;
            },
            assignParams(){
                if(this.datafilter){
                    this.columsConfig[0].options = this.datafilter.Users
                    this.columsConfig[1].options = [{ name: 'Todos', value: 'All' }, ...this.datafilter.Sellers]
                    this.columsConfig[2].options = [{ name: 'Todos', value: 'All' }, ...this.datafilter.Technical]
                    
                    this.columsConfig2[1].options = this.datafilter.Medidas;
                    this.columsConfig2[2].options = this.datafilter.Warehouses;
                    this.columsConfig2[3].options = this.datafilter.Families;
                    this.columsConfig2[4].options = this.datafilter.Categories;
                    this.columsConfig2[5].options = this.datafilter.SubCategories;
                    this.columsConfig2[6].options = this.datafilter.Users;
                    this.columsConfig2[7].options = this.datafilter.Sellers;
                    this.columsConfig2[8].options = this.datafilter.Technical;
                    this.Reloadfilter += 1;
                    this.Reloadfilter2 += 1;
                }
            },
            onExporting(e){
                const fecha = new Date().toISOString().slice(0, 10);
                printToExcel(e,`Reporte de ventas (${fecha})`)
            },
            onExporting2(e){
                const fecha = new Date().toISOString().slice(0, 10);
                printToExcel(e,`Reporte detallado de ventas (${fecha})`)
            },
            onExporting3(e){
                const fecha = new Date().toISOString().slice(0, 10);
                printToExcel(e,`Reporte detallado de ventas agrupado (${fecha})`)
            },
            onExporting4(e){
                const fecha = new Date().toISOString().slice(0, 10);
                printToExcel(e,`Reporte detallado de ventas totales por familia, categoría y subcategoría ${fecha}`)
            },
            filterHandler(data) {
                this.reportsData = data.data
                this.summary.totalCost = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.CostNotIva ), 0 ).toFixed( 2 )
                this.summary.totalDiscount = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.Discount ), 0 ).toFixed( 2 )
                this.summary.totalNotIva = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.PriceNotIva ), 0 ).toFixed( 2 )
                this.summary.totalIva = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.PriceWithIva ), 0 ).toFixed( 2 )
                this.summary.totalEarnings = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.Earnings ), 0 ).toFixed( 2 )
                this.summary.Iva = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.Iva ), 0 ).toFixed( 2 )
                this.summary.exentas = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.InvoiceTotalExenta ), 0 ).toFixed( 2 )
                this.summary.nosujetas = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.InvoiceTotalNoSuj ), 0 ).toFixed( 2 )
                this.summary.nogravadas = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.InvoiceTotalNoGravado ), 0 ).toFixed( 2 )
                this.summary.gravadas = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.InvoiceTotalGravada ), 0 ).toFixed( 2 )
                this.summary.total = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.Total ), 0 ).toFixed( 2 )
            },
            filterHandler2(data) {
                this.reportsData2 = data.data
                //this.dataGroupWarehouse = data.dataGroupWarehouse
                this.dataGroupFamilies = data.dataGroupFamilies
                /*this.summary.totalCost = numberWithCommas(parseFloat(data.totalCost).toFixed(2))
                this.summary.totalDiscount = numberWithCommas(parseFloat(data.totalDiscount).toFixed(2))
                this.summary.totalNotIva = numberWithCommas(parseFloat(data.totalNotIva).toFixed(2))
                this.summary.totalIva = numberWithCommas(parseFloat(data.totalIva).toFixed(2))
                this.summary.totalEarnings = numberWithCommas(parseFloat(data.totalEarnings).toFixed(2))*/
            },
            getEarningDetail() {
                this.loading = true;
                const params = {
                    start: this.start,
                    end: this.end,
                    typeData: this.typeData
                };
                
                // Agregar parámetro de sucursal si hay una seleccionada
                if (this.selectedBranch) {
                    params.ID_Branch = this.selectedBranch;
                }
                
                this.$API.inventoryReports.getEarningsReport(params).then(response => {
                    this.reportsData = response.data

                    this.summary.totalCost = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.CostNotIva ), 0 ).toFixed( 2 )
                    this.summary.totalDiscount = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.Discount ), 0 ).toFixed( 2 )
                    this.summary.totalNotIva = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.PriceNotIva ), 0 ).toFixed( 2 )
                    this.summary.totalIva = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.PriceWithIva ), 0 ).toFixed( 2 )
                    this.summary.totalEarnings = this.reportsData.reduce( ( total, current ) => total + parseFloat( current.Earnings ), 0 ).toFixed( 2 )
                }).
                catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false;
                })
            },
            getEarningDetailByItems() {
                this.loading = true;
                const params = {
                    start: this.start2,
                    end: this.end2,
                    typeData: this.typeData,
                    getGrouping: this.showGroupingNoDetails,
                    noShowInvalidation: this.noShowInvalidation,
                    getOnlyAirlaineTickets: this.getOnlyAirlaineTickets,
                };
                
                // Agregar parámetro de sucursal si hay una seleccionada
                if (this.selectedBranch) {
                    params.ID_Branch = this.selectedBranch;
                }
                
                this.$API.inventoryReports.getEarningsReportByItems(params).then(response => {
                    this.reportsData2 = response.data
                    this.dataGroupFamilies = response.dataGroupFamilies
                    //this.dataGroupWarehouse = response.dataGroupWarehouse
                    /*this.summary.totalCost = numberWithCommas(parseFloat(response.totalCost).toFixed(2))
                    this.summary.totalDiscount = numberWithCommas(parseFloat(response.totalDiscount).toFixed(2))
                    this.summary.totalNotIva = numberWithCommas(parseFloat(response.totalNotIva).toFixed(2))
                    this.summary.totalIva = numberWithCommas(parseFloat(response.totalIva).toFixed(2))
                    this.summary.totalEarnings = numberWithCommas(parseFloat(response.totalEarnings).toFixed(2))*/
                    
                }).
                catch(error => {
                    console.log(error);
                }).finally(()=> this.loading = false)
            },
            changueStr(date) {
                this.start = date;
            },
            changueStr2(date) {
                this.start2 = date;
            },
            changueEnd(date) {
                this.end = date;
            },
            changueEnd2(date) {
                this.end2 = date;
            },
            // Métodos para manejo de sucursales
            getBranches() {
                this.$API.branches
                    .findBranches(JSON.parse(localStorage.getItem("user")).businessid)
                    .then((data) => {
                        const allOption = {ID_Branch: 'all', BranchName: 'Todas las sucursales'}
                        this.branches = [allOption, ...data];
                        
                        // Establecer la sucursal del localStorage como seleccionada por defecto
                        const currentUserBranch = JSON.parse(localStorage.getItem("branch")).ID_Branch;
                        this.selectedBranch = currentUserBranch;
                        
                        // Obtener el nombre de la sucursal actual
                        const currentBranchData = data.find(branch => branch.ID_Branch == currentUserBranch);
                        if (currentBranchData) {
                            this.currentBranch = currentBranchData.BranchName;
                        }
                    })
                    .catch((err) => {
                        console.log("Error al obtener sucursales:", err);
                        this.$toasted.error("Error al cargar las sucursales");
                    });
            },
            onBranchChange() {
                // Este método se ejecuta cuando cambia la sucursal seleccionada
                if (this.selectedBranch) {
                    const selectedBranchData = this.branches.find(branch => branch.ID_Branch == this.selectedBranch);
                    if (selectedBranchData) {
                        this.currentBranch = selectedBranchData.BranchName;
                    }
                } else {
                    // Si se limpia la selección (botón X), volver a la sucursal por defecto del localStorage
                    const defaultBranch = JSON.parse(localStorage.getItem("branch")).ID_Branch;
                    this.selectedBranch = defaultBranch;
                    
                    const defaultBranchData = this.branches.find(branch => branch.ID_Branch == defaultBranch);
                    if (defaultBranchData) {
                        this.currentBranch = defaultBranchData.BranchName;
                    }
                }
                
                // Refrescar los filtros para que se actualicen con la nueva sucursal
                // this.Reloadfilter++;
                // this.Reloadfilter2++;
            }
        }
    }
</script>

<style scoped>
    .background {
        background: white !important;
        color: white;
    }
    
    /* Mejoras de responsividad para el contenedor */
    .versatile-filter-container {
        width: 100%;
        padding: 10px;
        overflow-x: hidden;
    }
    
    /* Media queries para dispositivos móviles */
    @media (max-width: 600px) {
        .v-radio-group {
            margin: 8px 12px !important;
        }
        
        .v-radio-group .v-radio {
            margin-bottom: 4px;
        }
        
        .v-tabs .v-tab {
            font-size: 0.875rem;
            padding: 0 8px;
        }
        
        .versatile-filter-container {
            padding: 0 4px;
        }
    }
    
    @media (max-width: 960px) and (min-width: 601px) {
        .v-radio-group {
            margin: 12px 16px !important;
        }
        
        .v-tabs .v-tab {
            font-size: 0.9rem;
        }
    }
</style>

<style>
    .dx-datagrid-rowsview .dx-row.dx-group-row td {
        text-align: left !important;
    }

    .hidden-rows .dx-datagrid-content .dx-data-row {
        display: none; /* Oculta todas las filas de datos */
    }
    
    /* Posicionar el selector de sucursal en la línea del filtro */
    .v-input--selection-controls {
        margin-top: 0 !important;
    }
</style>